/**
 * @generated SignedSource<<56cfb8d7556ac27b6db4b3fa4206a3a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "concreteType": "SendConfirmationInstructionsPayload",
    "kind": "LinkedField",
    "name": "sendConfirmationInstructions",
    "plural": false,
    "selections": [
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "success",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "needsAuthentication",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ValidationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "field",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "messages",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "MutationResult",
        "abstractKey": "__isMutationResult"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendConfirmationInstructionsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendConfirmationInstructionsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f5a854b724517389800d970c9fcc37e3",
    "id": null,
    "metadata": {},
    "name": "SendConfirmationInstructionsMutation",
    "operationKind": "mutation",
    "text": "mutation SendConfirmationInstructionsMutation(\n  $email: String!\n) {\n  sendConfirmationInstructions(email: $email) {\n    ... on MutationResult {\n      __isMutationResult: __typename\n      success\n      notice\n      needsAuthentication\n      errors {\n        field\n        messages\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "7b9a0ebbbfad175c3d6b18b3d05acc5d";

module.exports = node;
